import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import { Dialog, DialogContent, Typography, Button, Box } from '@mui/material';

const STATUS_CONFIG = {
  success: {
    defaultTitle: 'Registration Successful',
    icon: CheckCircleRoundedIcon,
    backgroundColor: '#22c55e',
    buttonColor: 'success',
  },
  error: {
    defaultTitle: 'Registration Failed',
    icon: ErrorRoundedIcon,
    backgroundColor: '#ef4444',
    buttonColor: 'error',
  },
};

const RegStatusDialog = ({
  open,
  onClose,
  status = 'success',
  title,
  message,
  buttonLabel = 'OK',
}) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.error;
  const StatusIcon = config.icon;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
        },
      }}
    >
      <DialogContent
        sx={{
          py: 5,
          px: { xs: 2.5, sm: 4 },
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            width: 90,
            height: 90,
            borderRadius: '50%',
            bgcolor: config.backgroundColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 3,
            animation: 'status-pop 0.4s ease-out',
            '@keyframes status-pop': {
              '0%': {
                transform: 'scale(0.5)',
                opacity: 0,
              },
              '100%': {
                transform: 'scale(1)',
                opacity: 1,
              },
            },
          }}
        >
          <StatusIcon
            sx={{
              color: '#fff',
              fontSize: 56,
            }}
          />
        </Box>

        <Typography variant="h5" fontWeight={700} gutterBottom>
          {title || config.defaultTitle}
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 4, whiteSpace: 'pre-line' }}
        >
          {message ||
            (status === 'success'
              ? 'E-ticket will be sent via email.'
              : 'Something went wrong. Please try again.')}
        </Typography>

        <Button
          type="button"
          variant="contained"
          color={config.buttonColor}
          fullWidth
          size="large"
          onClick={onClose}
          sx={{
            borderRadius: 2,
            py: 1.3,
            textTransform: 'none',
            fontWeight: 600,
          }}
        >
          {buttonLabel}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default RegStatusDialog;
